import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

export const Dot = styled.div`
  --dot-color: ${COLORS.systemSky200};

  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--dot-color);
  box-shadow: 0 0 0 2px ${COLORS.systemLight100};

  &.info {
    --dot-color: ${COLORS.systemSky200};
  }

  &.error {
    --dot-color: ${COLORS.systemFlame200};
  }
`;
